import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input, Selection } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';

import { EnumChannel } from 'enums';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Typeof, DraftUtils } from 'utils';

import './style.css';

class ModalLogbookEntry extends React.Component {

  constructor(props) {
    super(props);

    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.isEdit = Typeof.object(props.entry);

    let state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      },

      icon: 'add',
      title: 'Nouvelle entrée',
      entry: {},
      action: API.post,
      route: `/changelogs`,
      editorState: EditorState.createEmpty()
    };

    if (this.isEdit) {

      state = {
        ...state,
        icon: 'edit',
        title: 'Modification entrée',
        entry: this.props.entry,
        action: API.put,
        route: `/changelogs/${this.props.entry.channel}/${this.props.entry.version}`,
        editorState: DraftUtils.HTML2EditorState(this.props.entry.content)
      };
    }

    this.state = state;
  }

  handleEditorChange(value) {
    this.setState({
      editorState: value
    });
  }

  handleSubmit(data, onSucess, onError) {

    if (this.isEdit) {
      data.id = this.state.entry.id
    };

    data.content = DraftUtils.editorState2HTML(this.state.editorState);

    this.state.action(this.state.route, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    const { entry } = this.state;

    let channels = EnumChannel.values.map((channel) => {
      return {
        key: channel,
        value: channel,
        text: EnumChannel.name(channel)
      }
    });

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal id="changelog-modal" open size='large'>
          <Header icon={this.state.icon} content={this.state.title} />
          <Modal.Content>

            <FormWrapper actions={this.state.actions} sanitize>

              <Form.Group widths='equal'>

                {/* Version */}
                <Form.Field>
                  <label htmlFor="inputVersion" className="required">Version</label>
                  <Input type="text" id="inputVersion" name="version" value={entry.version} disabled={this.state.isEdit} />
                </Form.Field>

                {/* Channel */}
                <Form.Field>
                  <label htmlFor="inputChannel" className="required">Canal</label>
                  <Selection id="inputChannel" options={channels} name="channel" value={entry.channel} disabled={this.state.isEdit} noResultsMessage="Aucun canal disponible" />
                </Form.Field>

              </Form.Group>

              <Form.Field>
                <label htmlFor="inputContent" className="required">Contenu</label>
                <Editor editorState={this.state.editorState} onEditorStateChange={this.handleEditorChange} />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalLogbookEntry.propTypes = {
  onClose: PropTypes.func.isRequired,
  entry: PropTypes.shape({
    version: PropTypes.string,
    channel: PropTypes.string,
    content: PropTypes.string.isRequired
  })
};

export default ModalLogbookEntry;
